export type EventsSinkTableName = `${string}-sink-table`;
export type EventsSubscriptionsTableName = `${string}-subscriptions-table`;
